import { render, staticRenderFns } from "./RoleBinding.vue?vue&type=template&id=0ed114cc&"
import script from "./RoleBinding.vue?vue&type=script&lang=js&"
export * from "./RoleBinding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports